import { memo, useContext } from 'react';
import { Lightbulb } from '@trinity/chat-components/components/icons/Lightbulb.js';
import { AppThemingContext } from '@trinity/chat-components/containers/AppTheming/Context.js';
import styles from './style/Insights.LoadingProgress.module.css';

type Props = unknown;

export const LoadingProgress = memo((props: Props) => {
  const ctx = useContext(AppThemingContext);

  const fill = ctx?.enabled ? ctx?.palette?.primary?.main : undefined;
  const floodColor = ctx?.enabled ? ctx?.palette?.primary?.dark : '#5573b1';
  const stroke = ctx?.enabled ? ctx?.palette?.primary?.dark : '#5C73AD';

  return (
    <div className={styles.root}>
      <svg viewBox="0 0 100 100">
        <defs>
          <filter id="shadow">
            <feDropShadow
              dx="0"
              dy="0"
              stdDeviation="1.5"
              floodColor={floodColor} />
          </filter>
        </defs>
        <circle
          className={styles.spinner}
          stroke={stroke}
          cx="50"
          cy="50"
          r="45" />
      </svg>
      <div className={styles.lightbulb}>
        <Lightbulb
          className={styles.bulb}
          color={fill}
          size={24} />
      </div>
    </div>
  );
});

LoadingProgress.displayName = 'Insights.Panel.LoadingProgress';